import React from 'react'
import Link from 'gatsby-link'
import styled from 'react-emotion'
import { filter } from 'lodash'
import { createLink } from '../utils/whistle'
import Button from '../components/buttons/Button'

const CategoryContainer = styled.ul`
  display: flex;
  flex-wrap: wrap;
  padding: 1rem;
  background: #F8F8F8;

  @media (min-width: 800px) {
		display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    
  }
`

const CategoryTab = styled.li`
  list-style-type: none;
  margin-right: .5rem;

  a {
    font-size: 0.8rem;
    padding: 0.5rem 1rem;
  }

  @media (min-width: 800px) {
		a {
      font-size: 1rem;
      padding: 1rem;
    }
  }

`

const renderCategories = (root, categories) => {
  return categories.sort((a, b) => a.totalCount > b.totalCount ? -1 : 1).slice(0, 10).map((cat, i) => (
    <CategoryTab key ={i}>
      <Button flat to={`/${root}/${createLink(cat.fieldValue)}/`}>{cat.fieldValue}</Button>
    </CategoryTab>
  ))
}

const filterByCategroy = (categories, input) => {
  if (categories && input) {
    return filter(categories, (cat) => {
      return cat.description.indexOf(input) > -1 || cat.title.indexOf(input) > -1
    })
  } else {
    return categories
  }
}

class CategoryList extends React.Component {
  constructor(props) {
    super(props) 
    this.state = {
      search: ''
    } 
  }

  searchKeyword(search) {
    return this.setState({ search })
  }

  render() {
    return (
      <CategoryContainer>
        <CategoryTab>
          <Button flat to={`/${this.props.root}`}>All</Button>
        </CategoryTab>
        {renderCategories(this.props.root, filterByCategroy(this.props.categories, this.state.search))}
      </CategoryContainer>
      );
  }
}
 
export default CategoryList;



// WEBPACK FOOTER //
// ./src/templates/category-list.js